export default function range(start: number, end: number) {
  return Array.from({ length: end - start }, (v, idx) => idx + start);
}
